export default function initCheckoutPayment() {
    // A WooCommerce checkout eseményei jQuery custom eventek, ezért jQuery kell.
    // A checkout oldalon a WooCommerce mindig betölti a jQuery-t.
    const $ = window.jQuery;
    if (!$) return;

    // Csak a checkouton fusson
    if (!document.querySelector('.wc_payment_methods')) return;

    function syncPaymentSelected() {
        $('.wc_payment_methods .cbdonna-radio').removeClass('is-selected');
        $('.wc_payment_methods input[name="payment_method"]:checked')
            .closest('.cbdonna-radio')
            .addClass('is-selected');
    }

    // Felhasználói kattintás a fizetési módra
    $(document.body).on('change', 'input[name="payment_method"]', syncPaymentSelected);
    // WooCommerce AJAX újrarenderelés / mód-választás után
    $(document.body).on('updated_checkout payment_method_selected', syncPaymentSelected);
    // Kezdeti állapot
    syncPaymentSelected();
}
